import { Component, Input } from '@angular/core';
import { ProjectService } from '../../_core/services/project.service';
import { IElement } from 'src/app/_core/interfaces/IElement';
import { FrontProfile } from 'src/app/_core/models/profiles/front.model';
import { ElementType } from 'src/app/_core/models/ToolboxModel';
import { GlassWall } from 'src/app/_core/models/glasses/glassWall.model';
import { GlassWallDiamond } from 'src/app/_core/models/glasses/glassWallDiamond.model';

@Component({
	selector: 'card-in-offer',
	templateUrl: './in-offer.component.html',
	styleUrls: ['./../../card/card.component.css']
})
export class CardInOfferComponent {
	@Input() current: IElement;

	get inOffer() {
		return this.current.inOffer;
	}

	set inOffer(value) {
		this.current.inOffer = value;
		if (this.current instanceof FrontProfile) {
			this.projectService.profileService.roofElements[ElementType.Front].forEach(e => e.inOffer = value);
		} else if (this.current instanceof GlassWall || this.current instanceof GlassWallDiamond) {
			this.current.parts.forEach(part => part.inOffer = value);
		}
		this.projectService.emitChange();
	}

	constructor(public projectService: ProjectService) { }

}
